import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=05213fe6&scoped=true&"
import script from "./TransactionTable.vue?vue&type=script&lang=ts&"
export * from "./TransactionTable.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=05213fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05213fe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
